import React from "react";
import { Container } from "react-bootstrap";
import CareerAccordian from "../components/Career/CareerAccordian";
import JoinUs from "../components/Career/JoinUs";

const Career = () => {
  return (
    <Container fluid className="p-0">
      <CareerAccordian />
      <JoinUs />
    </Container>
  );
};

export default Career;
